<template>
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient">
    <div class="container">
      <div class="d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div><h3 class="text-white fw-bold">الإشتراك والفواتير</h3></div>
        <form class="search-form">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="container mt-4">
    <div class="row">
      <div class="col-lg-8 mx-auto">
        <div class="d-flex align-items-center">
          <h5 class="fs-4 fw-bold">الخطط</h5>
          <div class="d-flex ms-auto">
            <div class="border border-light py-3 bg-primary bg-opacity-10 rounded-pill d-flex align-items-center px-4 fs-5">
              <div class="switch-box plan-switch primary d-flex align-items-center">
                <span :class="yearly == true ? 'text-secondary' : 'text-primary'" class="me-2 fs-6 fw-bold">شهري</span>
                <input type="checkbox" checked="" id="switch" @click="yearly = !yearly" />
                <label for="switch">Toggle</label>
                <span :class="yearly == true ? 'text-primary' : 'text-secondary'" class="ms-2 fs-6 fw-bold">سنوي</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 mx-auto mb-4">
        <div class="row" style="margin-top: 5rem">
          <div class="col-12 col-lg-4 mb-5 mb-lg-0 mx-auto">
            <div class="card plans-card free-plan border-0">
              <div class="card-header d-flex flex-column position-relative">
                <h5 class="text-white fs-4 fw-bold">مجاني</h5>
                <div class="position-absolute top-0 translate-middle plan-logo">
                  <img src="@/assets/images/jad-free.svg" width="72" alt="" />
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span class="text-white fs-2 fw-bold">0</span>
                  <div class="d-flex flex-column">
                    <span class="fs-12px fw-bold text-white">دولار امريكي</span>
                    <span class="fs-12px fw-bold text-white">شهري</span>
                  </div>
                </div>
              </div>
              <div class="card-body d-flex flex-column border border-2 border-top-0">
                <ul class="p-0 services list-unstyled">
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                </ul>
                <div class="d-grid mt-auto">
                  <button @click="successToast()" class="btn btn-secondary rounded-pill">مفعل</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 mb-5 mb-lg-0 mx-auto">
            <div class="card plans-card primary-plan border-0">
              <div class="card-header d-flex flex-column position-relative">
                <h5 class="text-white fs-4 fw-bold">المميز</h5>
                <div class="position-absolute top-0 translate-middle plan-logo">
                  <img src="@/assets/images/jad-primary.svg" width="100" alt="" />
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span class="text-white fs-2 fw-bold">25</span>
                  <div class="d-flex flex-column">
                    <span class="fs-12px fw-bold text-white">دولار امريكي</span>
                    <span class="fs-12px fw-bold text-white">بالشهر</span>
                  </div>
                </div>
                <div class="offer-badge bg-primary text-center fs-12px text-white position-absolute top-100 translate-middle shadow-sm fw-bold">
                  وفر 150 دولار
                  <br />
                  بالخطة السنوية
                </div>
              </div>
              <div class="card-body d-flex flex-column border border-2 border-top-0">
                <ul class="p-0 services list-unstyled">
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                </ul>
                <div class="d-grid mt-auto">
                  <button @click="failToast()" class="btn btn-primary rounded-pill">ترقية</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 mb-5 mb-lg-0 mx-auto">
            <div class="card plans-card success-plan border-0">
              <div class="card-header d-flex flex-column position-relative">
                <h5 class="text-white fs-4 fw-bold">المميز اوي</h5>
                <div class="position-absolute top-0 translate-middle plan-logo">
                  <img src="@/assets/images/jad-success.svg" width="100" alt="" />
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span class="text-white fs-2 fw-bold">29</span>
                  <div class="d-flex flex-column">
                    <span class="fs-12px fw-bold text-white">دولار امريكي</span>
                    <span class="fs-12px fw-bold text-white">بالشهر</span>
                  </div>
                </div>
                <div class="offer-badge bg-success text-center fs-12px text-white position-absolute top-100 translate-middle shadow-sm fw-bold">
                  وفر 150 دولار
                  <br />
                  بالخطة السنوية
                </div>
              </div>
              <div class="card-body d-flex flex-column border border-2 border-top-0">
                <ul class="p-0 services list-unstyled">
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                          <path id="check" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                  <li class="fs-6 text-secondary mb-2 d-flex align-items-center gap-1">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                          <path id="circle" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="" fill-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                    نص وهمي
                  </li>
                </ul>
                <div class="d-grid mt-auto">
                  <button @click="successToast()" class="btn btn-success text-white rounded-pill">ترقية</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Setting :id="1" :title="'طرق الدفع'" :section_title="''" :icon="require('@/assets/images/credit-card.svg')" :status="'null'" :subtitle="'قم بإدارة طرق الدفع'" :visibility="true" :hasToggler="false">
      <div class="card platform-card bg-light border flex-row align-items-center border-2 d-flex py-2 px-3 gap-2 mb-3">
        <img src="@/assets/images/visa.svg" alt="" />
        <div class="d-flex flex-column">
          <div class="fs-6 mb-0">
            <span class="fw-bold">visa</span>
            <span class="text-secondary">/ الافتراضي</span>
          </div>
          <span class="fs-14px text-secondary">2010 •••••</span>
        </div>
        <div class="d-flex align-items-center ms-auto">
          <div class="dropdown">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="@/assets/images/dots.svg" alt="" />
            </button>
            <ul class="dropdown-menu rounded-3 border-0 shadow-sm dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li>
                <button class="dropdown-item border-bottom" @click="successToast()" type="button">تعيين كإفتراضي</button>
              </li>
              <li>
                <button data-bs-toggle="modal" data-bs-target="#removeCardModal" class="dropdown-item" type="button">حذف الكارد</button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card platform-card bg-light border flex-row align-items-center border-2 d-flex py-2 px-3 gap-2 mb-3">
        <img src="@/assets/images/master.svg" alt="" />
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold mb-0">Master Card</h5>
          <span class="fs-14px text-secondary">2010 •••••</span>
        </div>
        <div class="d-flex align-items-center ms-auto">
          <button class="btn dropdown-toggle" type="button">
            <img src="@/assets/images/dots.svg" alt="" />
          </button>
        </div>
      </div>
      <!-- Button -->
      <div class="">
        <button class="btn btn-outline-primary rounded-pill px-4 py-2 d-flex">
          <div class="svg-icon me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <g id="plus" transform="translate(-4 -4)">
                <path id="Line_1" data-name="Line 1" d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z" transform="translate(11.086 5)" fill="currentColor" />
                <path id="Line_2" data-name="Line 2" d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z" transform="translate(5 11.086)" fill="currentColor" />
              </g>
            </svg>
          </div>
          إضافة طريقة دفع
        </button>
      </div>
    </Setting>

    <Setting :id="2" :title="'الفواتير'" :section_title="''" :icon="require('@/assets/images/invoice.svg')" :status="'null'" :subtitle="'يمكنك الإطلاع على الفواتير من هذا القسم'" :visibility="true" :hasToggler="false">
      <Invoice v-for="item in items" :key="item.id" :item="item" />
    </Setting>

    <Modal :form_img="false" :is_alert="true" :alert_img="require('@/assets/images/alert-icon.svg')" :modal_title="'هل انت متأكد من حذف البطاقة؟'" :name="'removeCard'">
      <div class="fs-6 text-secondary mb-4">إن لم يكن لديك وسيلة دفع اخرى لن يتم تجديد اشتراكك تلقائيا</div>
      <div class="d-grid gap-2">
        <button class="btn btn-danger rounded-pill text-white fw-bold">حذف البطاقة</button>
        <button
            data-bs-dismiss="modal"
            aria-label="Close"
         class="btn btn-outline-primary rounded-pill fw-bold">إلغاء</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {ref} from '@vue/reactivity'
import Setting from '../components/Setting.vue'
import Invoice from '../components/Invoice.vue'
import {useToast} from 'vue-toastification'
import NotfySuccess from '../components/toasts/NotfySuccess.vue'
import NotfyFail from '../components/toasts/NotfyFail.vue'
import closeBtn from '../components/closeBtn.vue'
import Modal from '../components/Modal.vue'

export default {
  components: {Setting, Invoice, Modal},
  name: 'Plans',
  setup() {
    const yearly = ref(true)
    const toaster = useToast()
    const successToast = () => {
      toaster(NotfySuccess, {
        position: 'bottom-right',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: false,
        rtl: false,
        toastClassName: 'custom-toast primary-toast',
        closeButton: closeBtn,
        bodyClassName: ['py-2', 'px-3'],
        closeButtonClassName: 'close-btn',
      })
    }
    const failToast = () => {
      toaster(NotfyFail, {
        position: 'bottom-right',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: false,
        rtl: false,
        toastClassName: 'custom-toast danger-toast',
        closeButton: closeBtn,
        bodyClassName: ['py-2', 'px-3'],
        closeButtonClassName: 'close-btn',
      })
    }
    const items = ref([
      {
        id: 1,
        method: 'visa',
        card_number: '2010 •••••',
        status: 'نجحت',
        total: '12$',
        date: 'نيسان 23 2022',
      },
      {
        id: 2,
        method: 'master',
        card_number: '3030 •••••',
        status: 'فشلت',
        total: '12$',
        date: 'نيسان 23 2022',
      },
    ])
    return {yearly, items, successToast,failToast}
  },
}
</script>

<style>
</style>